var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-1 mb-6 rounded-lg mt-0"},[_c('v-card-title',{staticClass:"pa-7"},[_vm._v(" Přiřazení zákazníci "),_c('v-spacer')],1),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.orderHeadersByRole,"items":_vm.customer.items,"options":_vm.customer.options,"server-items-length":_vm.customer.serverItemsLength,"loading":_vm.customer.loading,"item-key":"id"},on:{"update:options":function($event){return _vm.$set(_vm.customer, "options", $event)}},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
            name: 'customers.detail',
            params: {
              customerId: item.id,
            },
          }}},[_vm._v(" "+_vm._s(item.id)+" ")])]}},{key:"item.phone",fn:function(ref){
          var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatPhoneNumber(item.phone))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }